import { useMemo } from 'react';
import { GridToolbarProps, Toolbar, ToolbarPropsOverrides } from '@mui/x-data-grid-pro';
import { useFetchConsignmentQuery } from '@api/Trinium/Endpoints/Consignment/slice';
import useCurrentTerminal from '@hooks/useCurrentTerminal';
import DynamicDropDown from '@components/DynamicDropDown';

import styles from './DataGrid.ItemLocationHistory.module.css';

/**
 * Toolbar that sits on top of the Item Location History data grid and displays actions available.
 */
export default function ItemLocationHistoryToolbar(props: GridToolbarProps & ToolbarPropsOverrides) {
	const { number: terminalNumber } = useCurrentTerminal();

	const { data: consignment, isFetching: fetchingConsignment } = useFetchConsignmentQuery(
		{
			terminalNumber,
			consignmentId: Number(props.itemLocationHistoryToolbarOverrides.consignmentId)
		},
		{
			skip: !props.itemLocationHistoryToolbarOverrides.consignmentId,
			refetchOnMountOrArgChange: true
		}
	);

	const legOptions = useMemo(() => {
		return consignment
			? [
					{ text: 'All', value: null },
					...consignment.consignmentLegs.map((leg) => ({
						text: `${String(leg.no)} - ${String(leg.type)}`,
						value: String(leg.id)
					}))
				]
			: [];
	}, [consignment]);

	return (
		<Toolbar className={styles.toolbar}>
			{!fetchingConsignment && legOptions.length > 0 && (
				<div className={styles['toolbar-item']}>
					<DynamicDropDown
						defaultValue={legOptions[0]}
						label='Leg'
						options={legOptions}
						optionKey={'text'}
						onChange={(option) => {
							props.itemLocationHistoryToolbarOverrides.onLegSelected(Number(option['value'] ?? null));
						}}
					/>
				</div>
			)}
		</Toolbar>
	);
}
